import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import MypageReturn from '../molecules/MypageReturn';
import { mypage_url } from '../Const';
import Popup from '../molecules/Popup';

interface Props {
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  tempSave: () => Promise<any>;
  moveNextStep: () => void;
  validate: () => Promise<any>;
  is_implement_online_identification?: boolean;
  requestModuleAutodisplay: () => void | boolean;
}

// KWANKGM04010_借入申込詳細
const FooterExaminationApplicantInput: React.FC<Props> = ({
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  tempSave,
  moveNextStep,
  validate,
  is_implement_online_identification,
  requestModuleAutodisplay,
}) => {
  const [modal_temp_save, setModalTempSave] = useState(false);
  const history = useHistory();

  /**
   * ナビゲーションを次に遷移
   * 下記画面に遷移
   *
   * KWANKGM04020_借入申込書類提出
   * KWANKGM04110_農業資金借入申込書類提出
   */
  const handleClickNext = async () => {
    const autodispay_result = await requestModuleAutodisplay();
    handleClickNextValidation();
  };

  /**
   * 次画面遷移前のバリデーション
   */
  const handleClickNextValidation = () => {
    validate().then(res => {
      if (!res) {
        return;
      }
      moveNextStep();
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/upload`);
    });
  };

  /**
   * 一次保存する押下時アクション
   */
  const handleClickOpenTempSave = () => {
    tempSave().then(res => {
      if (res) {
        setModalTempSave(true);
      }
    });
  };

  return (
    <>
      <Row className="mt-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-no-arrow">
          <div className="text-left sp-button-center">
            <a className="btn btn-xl btn-main-color " onClick={handleClickOpenTempSave}>
              一時保存する
            </a>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a
              className={`btn btn-xl btn-main-color sp-btn-height ml-auto ${is_implement_online_identification &&
                'disabled-bg'} `}
              onClick={handleClickNext}
            >
              借入申込をする
            </a>
          </div>
        </Col>
      </Row>
      <MypageReturn is_staff={is_staff} />
      <Popup
        title="一時保存完了"
        text="入力内容を一時保存しました。このまま入力を続けますか？"
        first_button={{
          label: '入力を続ける',
          variant: 'success',
          handleClick: () => setModalTempSave(false),
        }}
        second_button={{
          label: 'マイページへ戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalTempSave(false);
            location.href = mypage_url;
          },
        }}
        toggleClose={() => setModalTempSave(false)}
        toggleShow={modal_temp_save}
      />
    </>
  );
};

export default memo(FooterExaminationApplicantInput);
